if (!customElements.get("details-modal")) {
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }

  const trapFocusHandlers = {};

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;

      document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }

  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector("details");
      this.summaryToggle = this.querySelector("summary");

      this.detailsContainer.addEventListener(
        "keyup",
        (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
      );
      this.summaryToggle.addEventListener(
        "click",
        this.onSummaryClick.bind(this)
      );
      this.querySelectorAll(".js-search-modal-close").forEach((el) => {
        el.addEventListener("click", this.close.bind(this));
      });

      this.summaryToggle.setAttribute("role", "button");

      this.overlayEl = document.querySelector(`nss-overlay`);
      this.overlayDetails = {
        element: `details-modal`,
        zIndex: getComputedStyle(document.documentElement).getPropertyValue(`--nss-z-index-header-group`),
      }
    }

    isOpen() {
      return this.detailsContainer.hasAttribute("open");
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest("details").hasAttribute("open")
        ? this.close()
        : this.open(event);
    }

    onBodyClick(event) {
      if (
        !this.contains(event.target) ||
        event.target.classList.contains("modal-overlay")
      )
        this.close(false);
    }

    open(event) {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest("details").setAttribute("open", true);
      document.body.addEventListener("click", this.onBodyClickEvent);
      const overlayEvent = new CustomEvent("registerOverlay", {
        detail: this.overlayDetails
      });
      this.overlayEl.dispatchEvent(overlayEvent);

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    close(focusToggle = true) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute("open");
      document.body.removeEventListener("click", this.onBodyClickEvent);
      const overlayEvent = new CustomEvent("unregisterOverlay", {
        detail: this.overlayDetails
      });
      this.overlayEl.dispatchEvent(overlayEvent);
    }
  }

  customElements.define("details-modal", DetailsModal);
}
